import baseApi from "@/api/baseApi";
export default {
  addOrDelete(reportId, form) {
    return baseApi.post(`api-article/individual-report-article/v1/${reportId}`, form)
  },
  fetch(reportId) {
    return baseApi.get(`api-article/individual-report-article/v1/${reportId}`)
  }
}
